// extracted by mini-css-extract-plugin
module.exports = {"sosialeMedier":"SosialeMedier_sosialeMedier__CicdL","ikon":"SosialeMedier_ikon__r1L0I"};